import React, { Component } from 'react';
import { formatTimestamp } from '@/util/helpers/time-helpers';

class LastRefreshed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      update: 1,
    };
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.update();
    }, 10 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // updates state to force re-render
  update() {
    const { update } = this.state;
    this.setState({
      update: update * -1,
    });
  }

  // render timestamp
  render() {
    const { lastRefreshed } = this.props;

    return <span>{formatTimestamp(lastRefreshed)}</span>;
  }
}

export default LastRefreshed;
